module.exports = __webpack_public_path__ + "12bfb5d4203e53da19bf2b5336508464.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/logged-out/login-diamond-pattern@2x.png
// module id = 872
// module chunks = 0